var _rect, _path, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogsArrow = function SvgLogsArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4328,
    height: 36,
    viewBox: "0 0 4328 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    width: 4236,
    height: 36,
    fill: "#1C1C1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 1H100.123C101.982 1 103.687 2.03054 104.55 3.67583L110.85 15.6758C111.614 17.1311 111.614 18.8689 110.85 20.3242L104.55 32.3242C103.687 33.9695 101.982 35 100.123 35H62.5C58.9101 35 56 32.0899 56 28.5V7.5C56 3.91015 58.9101 1 62.5 1Z",
    stroke: "#6552FF",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 92,
    height: 30,
    fill: "url(#paint0_linear_14055_17143)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14055_17143",
    x1: 34,
    y1: 18,
    x2: -9.07001e-8,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1E",
    stopOpacity: 0
  })))));
};
export { SvgLogsArrow as ReactComponent };
export default __webpack_public_path__ + "logs-arrow.svg";